import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};

export const socialSignUpSlice = createSlice({
  name: "socialSignUpSlice",
  initialState,
  reducers: {
    socailSignUp: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { socailSignUp } = socialSignUpSlice.actions;

export default socialSignUpSlice.reducer;
